import * as React from "react"

import { cn } from "@/lib/utils"
import { noAutofillProps } from "@/lib/no-autofill"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      // Browser-level autofill suppression applied as DEFAULTS (18/02/2026).
      // Operational fields in the gestionale must not receive Edge/Chrome
      // personal-memory suggestions (saved emails, "Gestisci sito personale",
      // profile data, ecc.). The caller-supplied `{...props}` spread comes
      // AFTER these defaults so explicit autoComplete props on the Login /
      // password-change forms still win and keep their managed autofill.
      // See /app/frontend/src/lib/no-autofill.js for details.
      {...noAutofillProps}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
